<template>
  <div class="lee-platform-container">
    <!-- <lee-tiktok /> -->
    <lee-kuaishou />
  </div>
</template>
<script>
import LeeTiktok from "./tiktok.vue";
import LeeKuaishou from "./kuaishou.vue";
export default {
  components: {
    LeeTiktok,
    LeeKuaishou,
  },
  data() {
    return {
      active: "douyin",
    };
  },
};
</script>
<style lang="less" scoped>
.lee-platform-container {
  background: #fff;
}
</style>
